<template>
    <v-row v-if="routine" class="routine-card" align="center">
        <v-col cols="3" align="center">
            <v-avatar tile>
                <v-img :src="routineImg"/>
            </v-avatar>
        </v-col>
        <v-col cols="9">
            <div class="routine-date">
                {{ routineDate }}
            </div>
            <div class="routine-name text-truncate">
                {{ routine.name }}
            </div>
            <div class="routine-info">
                {{ routineBlocks }}
                <span class="mx-1"/>
                {{ routineDuration }}
            </div>
            <div class="routine-exercises">
                {{ routineExercises }}
            </div>
        </v-col>
    </v-row>
</template>

<script>
export default {
    name: "RoutineDateCard",
    props: {
        routine: {
            type: Object,
            default: null,
        }
    },
    computed: {
        routineImg(vm = this) {
            return vm.routine?.img || vm.imgPlaceholder
        },
        routineDate(vm = this) {
            return vm.$moment(vm.routine.rawDate.full).format('DD/MM/YY')
        },
        routineBlocks(vm = this) {
            return `${vm.routine?.blocks.length || 0} ${vm.$tc('common.blocks',2)}`
        },
        routineExercises(vm = this) {
            let exercises = 0
            vm.routine.blocks.forEach(block => {
                exercises += block.exercises.filter(exercise => exercise.type === 'exercise').length || 0
            })
            return `${exercises} ${vm.$t('common.exercises_short')}`
        },
        routineDuration(vm = this) {
            let minutes = 0
            vm.routine.blocks.forEach(block => {
                block.exercises.forEach(exercise => {
                    minutes += exercise.config && exercise.config.sets.length || 0
                })
            })
            let minutesString = vm.$t('common.minutes_short')
            let minutesAdded = Number(minutes * 1.3).toFixed()
            if (Number(minutes) === Number(minutesAdded)) return `${minutes} ${minutesString}`
            return `${minutes}-${minutesAdded} ${minutesString}`
        },
    }
}
</script>

<style scoped>

.routine-card {
    background: #FFFFFF;
    border: 1px solid #F9F9F9;
    border-radius: 4px;
}

.routine-name {
    font-weight: 800;
    font-size: 16px;
    line-height: 19px;
    color: #333333;
}

.routine-info {
    font-weight: 300;
    font-size: 12px;
    line-height: 14px;
    color: #333333;
    margin-top: 4px;
    margin-bottom: 4px;
    text-transform: lowercase;
}

.routine-exercises {
    font-weight: 300;
    font-size: 10px;
    line-height: 12px;
    color: #333333;
}

.routine-date {
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;
    color: #03342C;
    float: right;
}

</style>